import { UserPermissions } from '@/types/menu';

interface MenuCardProps {
  title: string;
  description: string;
  icon: string;
  onClick: () => void;
  isAvailable: boolean;
  permissionRequired?: keyof UserPermissions;
}

const MenuCard = ({
  title,
  description,
  icon,
  onClick,
  isAvailable,
}: MenuCardProps) => {
  return (
    <button
      onClick={onClick}
      disabled={!isAvailable}
      className={`card text-left transition-all duration-200 ${
        isAvailable
          ? 'hover:shadow-lg hover:scale-105 cursor-pointer'
          : 'opacity-50 cursor-not-allowed'
      }`}
    >
      <div className="flex items-start">
        <div className="text-4xl mr-4">{icon}</div>
        <div className="flex-1">
          <h3 className="text-xl font-semibold text-admin-text mb-2">{title}</h3>
          <p className="text-admin-textLight text-sm">{description}</p>
          {!isAvailable && (
            <div className="mt-3 inline-block px-3 py-1 bg-yellow-100 text-yellow-800 text-xs rounded">
              アクセス権限ありません
            </div>
          )}
        </div>
        <div className="ml-4">
          <svg
            className="w-6 h-6 text-admin-textLight"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 5l7 7-7 7"
            />
          </svg>
        </div>
      </div>
    </button>
  );
};

export default MenuCard;
